export default __webpack_public_path__ + "static/media/cart_icon.8183bda2.png";